import headerImg from "assets/images/v145/header.webp"
import infoImg from "assets/images/v145/info.webp"

export const v145Config = {
  header: { en: headerImg },
  info: { en: infoImg },
}
